// Typography primitives — the type scale as components. Every text style in the
// app is one of these; no improvised font-size/weight. `as` picks the element,
// className/style extend. Numeral/Eyebrow are the gamified + label shortcuts.
const MAP = {
  display: "bz-display", h1: "bz-h1", h2: "bz-h2", h3: "bz-h3",
  bodyLg: "bz-body-lg", body: "bz-body", label: "bz-label",
  micro: "bz-micro", eyebrow: "bz-eyebrow", numeral: "bz-numeral",
};
const DEFAULT_TAG = {
  display: "h1", h1: "h1", h2: "h2", h3: "h3", bodyLg: "p", body: "p",
  label: "span", micro: "span", eyebrow: "div", numeral: "span",
};

export function Text({ variant = "body", as, tone, className = "", style, children, ...rest }) {
  const Tag = as || DEFAULT_TAG[variant] || "span";
  const toneCls = tone === "muted" ? " bz-muted" : tone === "subtle" ? " bz-subtle" : tone === "accent" ? " bz-accent" : "";
  return (
    <Tag className={`${MAP[variant] || MAP.body}${toneCls} ${className}`.trim()} style={style} {...rest}>
      {children}
    </Tag>
  );
}

export const Display = (p) => <Text variant="display" {...p} />;
export const Title = (p) => <Text variant="h1" {...p} />;
export const Heading = (p) => <Text variant="h2" {...p} />;
export const Subheading = (p) => <Text variant="h3" {...p} />;
export const Eyebrow = (p) => <Text variant="eyebrow" {...p} />;
export const Numeral = (p) => <Text variant="numeral" {...p} />;
export const Micro = (p) => <Text variant="micro" {...p} />;
